import { z } from 'zod';

export const checkoutResponseSchema = z.object({ url: z.string().url() });
export type CheckoutResponse = z.infer<typeof checkoutResponseSchema>;

export const portalResponseSchema = z.object({ url: z.string().url() });

/**
 * Days a subscriber keeps paid features after a failed payment. Signing up is
 * free and stays free, so this is the only window that expires.
 */
export const PAST_DUE_GRACE_DAYS = 7;
